<template>
    <div class="container container-tabs">
        <el-tabs v-model="activeName" @tab-click="handleClick" type="card">
            <el-tab-pane name="all" class="to-searh">
                <span slot="label" class="table-title">全部</span>
            </el-tab-pane>

            <el-tab-pane :name="String(item.val)" v-for="(item, index) in value_status_code" :key="index" class="to-searh">
                <span slot="label" class="table-title">{{ item.alias }}</span>
            </el-tab-pane>

            <div class="handle-box">
                <el-row class="head-search">
                    <el-col :span="12">
                        <span class="title">用户手机:</span>
                        <!-- 搜索司机名称-->
                        <el-input
                            v-model="search_data.consumer_phone"
                            placeholder="请输入用户手机"
                            class="handle-input mr10"
                            @keyup.enter.native="searchCouponLists"
                            maxlength="11"
                            style="width: 200px"
                        ></el-input>
                    </el-col>
                    <el-col :span="12">
                        <span class="title">优惠券:</span>

                        <el-select
                            v-model="value_coupon_code"
                            placeholder="请选择优惠券"
                            @change="couponChange"
                            clearable
                            filterable
                            @keyup.enter.native="searchCouponLists"
                            style="position: relative; width: 200px"
                        >
                            <el-option
                                v-for="(item, index) in options_coupon_code"
                                :key="index"
                                :label="item.name"
                                :value="item.coupon_mode_code"
                            >
                            </el-option>
                        </el-select>
                    </el-col>
                </el-row>
            </div>

            <div>
                <el-button type="primary" icon="el-icon-search" @click="searchCouponLists">搜索</el-button>
                <el-button @click="add_isShow = !add_isShow">发放</el-button>
                <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
                <el-button :icon="progress_show ? 'el-icon-loading' : 'el-icon-setting'" @click="toExport" :disabled="progress_show"
                    >{{ progress_show ? '导出中...' : '导出' }}
                </el-button>
            </div>
        </el-tabs>

        <!-- 表格 -->
        <el-table
            :data="tableData"
            style="width: 100%"
            ref="multipleTable"
            header-cell-class-name="table-header"
            @selection-change="handleSelectionChange"
        >
            <el-table-column type="expand">
                <template slot-scope="props">
                    <el-form label-position="left" inline class="demo-table-expand">
                        <div class="more-style">
                            <el-form-item label="可用日期:">
                                <p v-for="item in props.row.coupon_mode.details.date_synchronization.month">{{ item }}月</p>
                                <p v-for="item in props.row.coupon_mode.details.date_synchronization.day">{{ item }}日</p>
                                <p v-for="item in props.row.coupon_mode.details.date_synchronization.week">星期{{ item }}</p>
                            </el-form-item>

                            <el-form-item label="可用时间段:">
                                <div v-for="item in props.row.coupon_mode.details.time_synchronization">
                                    <p>开始时间：{{ item.start_time }}</p>
                                    <p>截止时间：{{ item.end_time }}</p>
                                </div>
                            </el-form-item>
                        </div>

                        <div class="more-style">
                            <el-form-item label="领取限制:">
                                <p>每年{{ props.row.coupon_mode.details.receive_synchronization.year }}张</p>
                                <p>每月{{ props.row.coupon_mode.details.receive_synchronization.month }}张</p>
                                <p>每周{{ props.row.coupon_mode.details.receive_synchronization.week }}张</p>
                                <p>每天{{ props.row.coupon_mode.details.receive_synchronization.day }}张</p>
                            </el-form-item>
                        </div>
                        <div class="more-style">
                            <el-form-item label="订单编号:">
                                <p>{{ props.row.order_code }}</p>
                            </el-form-item>
                        </div>
                    </el-form>
                </template>
            </el-table-column>

            <el-table-column prop="id" label="id" width="80"> </el-table-column>

            <el-table-column prop="coupon_mode.details.name" label="优惠券名称" min-width="150"> </el-table-column>

            <el-table-column prop="coupon_mode.details.city.name" label="所属城市" min-width="150">
                <template slot-scope="scope">
                    <el-popover trigger="hover" placement="top">
                        <p>城市唯一编码: {{ scope.row.coupon_mode.details.city.city_code }}</p>
                        <div slot="reference">
                            <el-tag size="medium" style="border: 0; background-color: #fff; color: #333">
                                {{ scope.row.coupon_mode.details.city.name }}
                            </el-tag>
                        </div>
                    </el-popover>
                </template>
            </el-table-column>

            <el-table-column prop="consumer.details.name" label="拥有人" width="150"> </el-table-column>

            <el-table-column prop="consumer.details.phone" label="拥有人电话" width="150"> </el-table-column>

            <el-table-column prop="coupon_mode.details.full_price" label="满减条件" width="150"> </el-table-column>

            <el-table-column prop="coupon_mode.details.sub_price" label="满减金额" width="150"> </el-table-column>

            <el-table-column label="状态">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.status.val == '0' ? 'warning' : scope.row.status.val == '1' ? '' : 'danger'">
                        {{ scope.row.status.alias }}</el-tag
                    >
                </template>
            </el-table-column>

            <el-table-column prop="source.alias" label="来源"> </el-table-column>

            <el-table-column prop="time.YmdHis" width="150" label="发放时间"> </el-table-column>
            <el-table-column width="150" label="操作">
                <template slot-scope="scope">
                    <el-button
                        :type="scope.row.status.val == '0' ? 'primary' : 'danger'"
                        @click="executeCouponStatusSubmit(scope.row)"
                        :disabled="scope.row.status.val == 3"
                        >{{ scope.row.status.val == '0' ? '启用' : '禁用' }}</el-button
                    >
                </template>
            </el-table-column>

            <!-- <el-table-column label="操作" width="150">
        <template slot-scope="scope">

          <el-dropdown trigger="click" split-button
            type="primary"
            @click="toDetails(scope.row.coupon_code)"
            >

            <el-dropdown-menu slot="dropdown">

              <el-dropdown-item @click.native="executeCouponStatusSubmit(scope.row.coupon_code,scope.row.status.val)" :disabled="scope.row.status.val == 3" v-if="scope.row.status.val == '0' || scope.row.status.val == '1'">{{ scope.row.status.val == '0'?'可用':'禁用' }}</el-dropdown-item>

            </el-dropdown-menu>

            查看记录

          </el-dropdown>

        </template>
      </el-table-column> -->
        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>

        <!-- 添加优惠券组件 -->
        <addcouponLists :isShow="add_isShow" @onSubmit="couponLists"></addcouponLists>

        <!-- 修改优惠券组件 -->
        <!-- <editCoupon :isShow="edit_isShow" :data="editCoupon_children" @onSubmit="couponLists"></editCoupon> -->
    </div>
</template>

<script>
var _this;
//设置一个遮罩层缓存
var loading;
import addcouponLists from './addcouponLists.vue';
// import editCoupon from './editCoupon.vue';
export default {
    components: {
        addcouponLists
        // editCoupon
    },
    data() {
        return {
            progress_show: false,

            selectPages_coupon_data: [],
            value_coupon_code: '',
            coupon_options_data: {
                page: 1,
                limit: 50
            },

            options_coupon_code: [],

            excelData: [],

            excelHead: [],

            // 选项卡默认选中项
            activeName: 'all',

            // 添加用户信息组件开关
            add_isShow: false,

            // 修改用户信息组件开关
            edit_isShow: false,

            // 传入子组件的数据
            editCoupon_children: '',

            // 下拉搜索状态
            value_status_code: '',
            status_select: [],

            // 存放表格数据
            tableData: [],

            //翻页数据
            search_data: {
                page: 1,
                limit: 10,
                status: '',
                consumer_phone: '',
                coupon_mode_code: ''
            },

            result_data: [],
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
        _this.couponList();
        _this.searchCouponLists();
    },

    methods: {
        beforeUnload(event) {
            // 设置returnValue属性以显示提示信息
            event.returnValue = '你确定要离开吗？';

            // 注意：现代浏览器不允许自定义提示信息，只会显示一个标准的警告信息
        },

        couponList() {
            _this.coupon_options_data.page = 1;
            _this.options_coupon_code = [];
            _this.getCoupon();
        },
        getCoupon() {
            _this
                .$post('/coupon/CouponModeLists', _this.coupon_options_data)
                .then((res) => {
                    for (let i = 0; i < res.data.length; i++) {
                        _this.options_coupon_code.push(res.data[i]);
                    }

                    if (_this.coupon_options_data.page * _this.coupon_options_data.limit < res.count) {
                        _this.coupon_options_data.page += 1;
                        _this.getCoupon();
                    }
                })
                .catch((err) => {});
        },
        couponChange(val) {
            _this.search_data.coupon_mode_code = val;
        },

        toExport() {
            _this.search_data.page = 1;

            _this.getExcelData();
        },
        getExcelData() {
            _this
                .$post('/coupon/couponLists', _this.search_data)
                .then((res) => {
                    _this.progress_show = true;
                    loading = _this.$loading({
                        lock: true,
                        text: '正在导出,请勿刷新页面，请耐心等待...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(255, 255, 255, 0.7)',
                        customClass: 'sendCoupon-loading'
                    });

                    window.addEventListener('beforeunload', this.beforeUnload);

                    if (this.$route.path == '/couponLists') {
                        // 导出excel的空数组中添加数据
                        for (let i = 0; i < res.data.length; i++) {
                            _this.excelData.push({
                                name: res.data[i].coupon_mode.details.name,
                                city: res.data[i].coupon_mode.details.city.name,
                                Yname: res.data[i].consumer.details.name,
                                phone: res.data[i].consumer.details.phone,
                                full_price: res.data[i].coupon_mode.details.full_price,
                                sub_price: res.data[i].coupon_mode.details.sub_price,
                                status: res.data[i].status.alias,
                                source: res.data[i].source.alias,
                                time: res.data[i].time.YmdHis
                            });
                        }

                        console.log(_this.search_data.page * _this.search_data.limit, '======');

                        if (_this.search_data.page * _this.search_data.limit < res.count) {
                            _this.search_data.page += 1;

                            // _this.progress_data = Math.floor((res.data.page * res.data.limit / res.data.count) * 100);

                            _this.getExcelData();
                        } else {
                            console.log(_this.excelData);
                            window.removeEventListener('beforeunload', this.beforeUnload);

                            // 如果loading存在则关闭loading遮罩
                            if (loading) {
                                loading.close();
                            }

                            // 将数据导出execl
                            _this.exportData();

                            _this.search_data.page = 1;

                            // 清空数据
                            _this.excelData = [];

                            _this.progress_show = false;
                        }
                    } else {
                        _this.progress_show = false;
                    }
                })
                .catch((err) => {});
        },

        // 导出excel方法
        exportData() {
            const { export_json_to_excel } = require('@/vendor/Export2Excel');
            const tHeader = ['优惠券名称', '所属城市', '拥有人', '拥有人电话', '满减条件', '满减金额', '状态', '来源', '发放时间'];
            const filterVal = ['name', 'city', 'Yname', 'phone', 'full_price', 'sub_price', 'status', 'source', 'time'];
            const list = this.excelData;
            const data = this.formatJson(filterVal, list);
            export_json_to_excel(tHeader, data, 'fileName');
        },

        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]));
        },

        // 查看记录方法
        toDetails(code) {
            console.log(code, 'code');

            this.$router.push({
                path: 'couponRecordLists',
                query: {
                    coupon_code: code
                }
            });
        },

        searchCouponLists() {
            _this.search_data.page = 1;
            _this.couponLists();
        },

        // 选项卡选中事件
        handleClick(tab, event) {
            // 点击的选项卡所对应的val值
            console.log(tab.name);
            if (tab.name != 'all') {
                _this.search_data.status = tab.name;
            } else {
                _this.search_data.status = '';
            }
            _this.search_data.page = 1;
            _this.couponLists();
        },
        // 启用禁用
        executeCouponStatusSubmit(e) {
            var sub_status = '';

            if (e.status.val == '0') {
                sub_status = '1';
            } else if (e.status.val == '1' || e.status.val == '2') {
                sub_status = '0';
            }

            _this
                .$post('/coupon/executeCouponStatusSubmit', {
                    coupon_code: e.coupon_code,
                    status: sub_status
                })
                .then((res) => {
                    _this.$message.success(res.msg);
                    _this.couponLists();
                })
                .catch((err) => {});
        },

        // 搜索用户管理列表
        couponLists() {
            _this
                .$post('/coupon/couponLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data;
                    _this.result_data = res;

                    // 状态下拉的数据
                    _this.value_status_code = _this.tableData[0].status.select_array;
                })
                .catch((err) => {});
        },
        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.couponLists();
        },
        handleSelectionChange(val) {
            var datalist = [];

            for (var i in val) {
                datalist.push(val[i].driver_code);
            }
            _this.delDriverSubmit_data.driver_code_array = datalist;
        },

        statusChange(val) {
            console.log(val.toString());

            _this.search_data.status = val.toString();
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 200px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}
</style>
